import {
  createRoute,
  lazyRouteComponent,
  Outlet,
} from '@tanstack/react-router';
import { protectedRoute, redirect } from './_root';

export const messagingRoute = createRoute({
  getParentRoute: () => protectedRoute,
  path: 'messaging',
  component: Outlet,
});

export const messagingIndexRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: '/',
  beforeLoad: () => {
    throw redirect({ to: '/messaging/templates' });
  },
});

export const messagingTemplatesRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: 'templates',
  component: lazyRouteComponent(() =>
    import('@whatsapp/pages/message-templates').then((m) => ({
      default: m.MessageTemplatesPage,
    }))
  ),
});

export const messagingDefaultTemplatesRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: 'default-templates',
  component: lazyRouteComponent(() =>
    import('@whatsapp/pages/default-message-templates').then((m) => ({
      default: m.DefaultMessageTemplatesPage,
    }))
  ),
});

export const messagingExpireRulesRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: 'expire-rules',
  component: lazyRouteComponent(() =>
    import('@whatsapp/pages/expire-rules').then((m) => ({
      default: m.ExpireRulesPage,
    }))
  ),
});

export const messagingSentTimeRulesRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: 'sent-time-rules',
  component: lazyRouteComponent(() =>
    import('@whatsapp/pages/sent-time-rules').then((m) => ({
      default: m.SentTimeRulesPage,
    }))
  ),
});

export const messagingSettingsRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: 'settings',
  component: lazyRouteComponent(() =>
    import('@whatsapp/pages/messaging-settings').then((m) => ({
      default: m.MessagingSettingsPage,
    }))
  ),
});

export const messagingProcessActionsRoute = createRoute({
  getParentRoute: () => messagingRoute,
  path: 'process-actions',
  component: lazyRouteComponent(() =>
    import('@whatsapp/pages/process-actions').then((m) => ({
      default: m.ProcessActionsPage,
    }))
  ),
});
